import { message } from "antd"
import axios from "../axios-interceptor.js"

let tenantId = localStorage.getItem("tenantId")
const BACKEND_API = process.env.REACT_APP_BACKEND_API;


export const successResponse = (data, responseObj, isArr = true, status = 200) => {
  let obj = { ...responseObj, status: status, message: data.message }
  obj.data = data.result ? data.result : isArr ? [] : {}
  return obj
}

export const errorResponse = (err, responseObj, isArr = true) => {
  let obj = { ...responseObj, status: 500 }
  obj.message = err?.response?.data?.message || err.message
  obj.data = isArr ? [] : {}
  return obj
}


export const createSpace = async (postData, userInfo) => {
  let responseObj = { status: "", message: "", data: {} }
  try {
    let response = await axios({
      method: postData.spaceId ? "PUT" : "POST",
      url: `${BACKEND_API}/space`,
      data: { ...postData },
      headers: {
        userId: userInfo.userId,
        tenantId: tenantId
      },
    });
    responseObj = successResponse(response.data, responseObj, false, response.status)
    if (response.status === 200) {
    }
  }
  catch (err) {
    responseObj = errorResponse(err, responseObj, false)
  }
  return responseObj
}

export const copySpace = async (postData, userInfo) => {
  let responseObj = { status: "", message: "", data: {} }
  try {
    let response = await axios({
      method: "POST",
      url: `${BACKEND_API}/space-copy`,
      data: { ...postData },
      headers: {
        userId: userInfo.userId,
        tenantId: tenantId
      },
    });
    responseObj = successResponse(response.data, responseObj, false,  response.status)
    if (response.status === 200) {

    }
  }
  catch (err) {
    responseObj = errorResponse(err, responseObj, false)
  }
  return responseObj
}

export const getSpaceDetails = async (spaceId) => {
  let responseObj = { status: "", message: "", data: {} };
  try {
    let res = await axios({
      method: "GET",
      url: `${BACKEND_API}/space/${spaceId}`,
      headers: {
        userId: "1",
        tenantId: tenantId
      },
    });
    if (res.status === 200) {
      responseObj = successResponse(res.data, responseObj, false)
    } else {
      responseObj.message = res.data.message
      responseObj.status = res.status
    }
  } catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const getUserSpaces = async (userEmail) => {
  let responseObj = { status: "", message: "", data: [] };
  try {
    let res = await axios({
      method: "GET",
      url: `${BACKEND_API}/space/user`,
      headers: {
        tenantId: tenantId
      },
    });
    if (res.status === 200) {
      responseObj = successResponse(res.data, responseObj, true)
    } else {
      responseObj.message = res.data.message
      responseObj.status = res.status
    }
  } catch (error) {
    responseObj = errorResponse(error, responseObj, true)
  }
  return responseObj
}

export const getSpaceUsers = async (spaceId) => {
  let responseObj = { status: "", message: "", data: [] };

  try {
    let res = await axios({
      method: "GET",
      url: `${BACKEND_API}/user`,
      params: {
        spaceId,
      },
    });
    if (res.status === 200) {
      responseObj = successResponse(res.data, responseObj, false)
    } else {
      responseObj.message = res.data.message
      responseObj.status = res.status
    }
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const deleteSpace = async (spaceId) => {
  let responseObj = { status: "", message: "", data: [] };

  try {
    let response = await axios({
      method: "DELETE",
      url: `${BACKEND_API}/space/${spaceId}`,
      headers: {
        tenantId: tenantId
      },
    });
    if (response.status === 200) {
      responseObj.data = response.data.result;
    }
    responseObj.status = response.status
    responseObj.message = response.data.message
  }
  catch (error) {

  }
  return responseObj
}